import React from 'react';

const TennisEventsScore = ({
  playerOneSetScore,
  playerTwoSetScore,
  setsScoreHistory,
}) => (
  <div className="table-match">
    <div className="table-match__live">
      <div className="table-match__live-point mr-1">
        <div className="table-match__live-pointValue">P1</div>
        <div className="table-match__live-pointValue">P2</div>
      </div>
      <div className="table-match__live-point table-match__live-point--set">
        <div className="table-match__live-pointValue">{playerOneSetScore || 0}</div>
        <div className="table-match__live-pointValue">{playerTwoSetScore || 0}</div>
      </div>
      <div className="table-match__points">
        {setsScoreHistory && setsScoreHistory.map((history, idx) => (
          <div
          // eslint-disable-next-line react/no-array-index-key
            key={`history-${history?.playerOnePointsScore}-${history?.playerTwoPointsScore}-${idx}`}
            className={`match__points-s${idx + 1}`}
          >
            <div className="table-match__points-value">
              {history?.playerOneGamesScore}
              {history?.isTieBreak && (<sup>{history.playerOnePointsScore}</sup>)}
            </div>
            <div className="table-match__points-value">
              {history?.playerTwoGamesScore}
              {history?.isTieBreak && (<sup>{history.playerTwoPointsScore}</sup>)}
            </div>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default TennisEventsScore;
